import React from 'react';
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core/styles";
import MiniLineChart from "../pages/Producao/PainelTVProducao/miniLineChart";
import classNames from "classnames";

const useStyles = makeStyles(theme => ({

    gridExterno: {
        display: 'flex',
        flexDirection:'column',
        flexwrap: 'nowrap',
        flexGrow: 3,

        margin: 0,
        padding: '16px',

        minHeight: '150px',
      //  marginBottom:'30px',
        // width: '120px'

    },
    mainGrid: {
        display: 'flex',
        flexDirection:'row',
        flexwrap: 'wrap',
        flexGrow: 12,
        backgroundColor: 'white',
        borderColor: 'black',
        borderRadius: '15px',
        // borderStyle: 'solid',
        // alignSelf: 'stretch',
    },

    nomeEtapa: {
        //backgroundColor: 'red',
        display: 'flex',
        justifyContent: 'center',
        alignSelf: 'center',
        borderBottom: '1px solid red',
        fontSize: '4em'
    },
    valoresArea: {
      //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        marginTop: '15px'

    },
    valoresAreaChart: {
        //  backgroundColor: 'green'
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        height: '100px',
        justifyContent: 'center'

    },
    fila: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    concluidos: {
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    tempomedio: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        alignSelf: 'center',
        fontSize:'2rem'
    },
    tempoLabel: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'flex-end',
        paddingTop: '2px'
    },
    tempoValor: {
        display: 'flex',
        flexDirection: 'row',
        justifyItems: 'center',
        justifyContent: 'space-evenly'

    }


}));

const ProduzidosGrid = (props) => {
    const { dados, titulo, legenda, observacao, historico, styleTitulo} = props;
    const classes= useStyles();

    let descr = '--';
    if (typeof  dados === "undefined") {
        descr = "--";
    } else {
        if (Array.isArray(dados)) {
            descr = dados.length;
        } else {
            if (dados != null) {
                descr = dados;
            }
        }
    }
    let obs = observacao;
    if (!observacao) { obs = ' '}


        return (
            <Grid id={'osTotaisGridExterno'} item container className={classes.gridExterno} xs={12} sm={12} md={12} lg={12} xl={12}>
                <Grid container item className={classes.mainGrid} xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Grid item className={classes.nomeEtapa} style={styleTitulo}  xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Typography variant="h4" style={{ fontSize: '0.6em'}}>{titulo}</Typography>
                    </Grid>
                    <Grid item container className={classes.valoresArea} xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid item container className={classes.concluidos} xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography variant="h2" style={{fontWeight:"fontWeightBold", fontSize: '10em'}}>{descr}</Typography>
                            <Typography variant="overline">{legenda}</Typography>
                            <Typography variant="h3" style={{fontWeight:"fontWeightBold"}}>{obs}</Typography>
                        </Grid>


                                {historico && historico.length > 0 &&
                                    <Grid item container className={classes.valoresAreaChart} xs={12} sm={12} md={12} lg={12} xl={12}>
                                            <MiniLineChart data={historico}/>
                                    </Grid>
                                }

                    </Grid>

                </Grid>
            </Grid>
        )
    }

export default ProduzidosGrid;


